module.exports = __webpack_public_path__ + "img/1.2bf65243.png";